// All Common Helper Function like Date formatt,NUll Checks
declare global {
  interface Window {
    dataLayer: any[]
  }
}

export class Util {
  /*
	  Function checks for Enter key and Space Bar key pressed event and call the respective functions
	  @return the boolean value
	*/
  static keyHandler = (event: any, func: any): boolean => {
    const KEY_ENTER = 13
    const KEY_SPACE = 32
    switch (event.which) {
      case KEY_SPACE:
      case KEY_ENTER: {
        event.stopPropagation()
        return func
        break
      }
    } // end switch
    return true
  }

  // static setAndTransferCookie(CookieName: any, value: any) {
  //   document.cookie = CookieName + '=' + JSON.stringify(value) + ';' + "Domain=vanguard.com;path=/";
  // }

  static setCookie = (name: any, value: any, days: any) => {
    let expires = ''
    if (days) {
      const date = new Date()
      const hour = 24
      const min = 60
      const second = 60
      const days = 1000
      date.setTime(date.getTime() + days * hour * min * second * days)
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie =
      name +
      '=' +
      (JSON.stringify(value) || '') +
      expires +
      'domain=vanguard.com;' +
      'path=/'
    // addSecure and HttpOnly before deploying
  }

  static getCookie = (name: any) => {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (const value of ca) {
      let c = value
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }
      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
    }
    return null
  }

  // ** Anaylitcs events section starts. Contains static fuctions to add adobe analytics events to data layer.
  //  Based on developer need, they can consume these functions to trigger analytics event.
  // Global Page Flow control for analytics

  static pageLoad(
    siteSection1: any,
    siteSection2: any,
    userProfile,
    isVGIUser,
  ) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'pageLoaded',
      page: {
        pageTitle: siteSection2,
        pageName:
          'us:en:mpm:web:myplanmanager:secure:' +
          siteSection1 +
          ':' +
          siteSection2,
        siteSection1: siteSection1,
        siteSection2: siteSection2,
        siteIdentifier: userProfile ? 'internalmpm' : 'externalmpm',
        platform: 'web',
        is404: false, //string true/false value
        DLVersion: '1.0.0',
        isVGIUser: isVGIUser,
      },
    })
  }

  //Used to convey information about the current user
  static userDetected(
    planNumber,
    currentUserSPOID,
    crewsPOID,
    isVGIUser,
    plansString,
    responsibilityCenter,
    clientNumber,
  ) {
    console.log(planNumber)

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'userDetected',
      user: {
        loginStatus: 'logged in',
        sPOID: currentUserSPOID,
        CRMContactID: '',
        crewFlag: '',
        crewsPOID: crewsPOID,
        clientTenure: '',
        clientNumber: clientNumber,
        CRMCompanyNumber: '',
        industryCode: '',
        responsibilityCenter: responsibilityCenter,
        allParticipantPlans: plansString,
        demoPlanFlag: '',
        isVGIUser: isVGIUser,
      },
    })
    // console.log(window.dataLayer)
    // Util.userSignedIn(true)
  }
  static userDetects(isVGIUser) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'userDetected',
      user: {
        loginStatus: 'logged out',
        isVGIUser: isVGIUser,
      },
    })
  }

  //Plan selected is used to convey information about the current user and if he is making changes to its choice of plans.

  static planSelected = (planNumber: any, isDefaultPlan: boolean) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'planSelected',
      planSelected: {
        planNumberString: planNumber,
        defaultPlan: isDefaultPlan,
      },
    })
  }

  //Navigation Handler convey information about the current user.
  static navigationHandler = (route: string, toPage: string) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'navigationEvent',
      planSelected: {
        routeName: route,
        toPagename: toPage,
      },
    })
  }

  //Used to track successful user sign in

  static signout = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'userSignedOut',
    })
  }

  //Use to track the conversion of user

  static clickToAction = (ctaName: string, location: string, ctaType: any) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'callToAction',
      callToAction: {
        ctaName: ctaName,
        location: location,
        ctaType: ctaType,
      },
    })
  }

  //Used to signify the end of page load event communication
  //Useful when the desire is to combine info from several pushed events.

  static pageLoadCompleted = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'pageLoadCompleted',
    })
  }

  //Used to track successful user sign in.
  static userSignedIn = (signInFlag: boolean) => {
    // console.log("in user sign in");
    window.dataLayer = window.dataLayer || []
    if (signInFlag) {
      window.dataLayer.push({
        event: 'userSignedIn',
        login: {
          loginMethod: signInFlag,
        },
      })
    } else {
      window.dataLayer.push({
        event: 'userSignedIn',
        login: {
          loginMethod: 'false',
        },
      })
    }
    // console.log(window.dataLayer)
  }

  //this event is used for tracking Internal Search Results
  static employeeSearch = (userInput: string) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'internalSearchConducted',
      searchInfo: {
        searchTermEntered: userInput,
        searchType: 'global',
      },
    })
  }

  static feedbackEvent = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'callToAction',
      callToAction: {
        ctaName: 'feedback',
        location: 'footer',
        ctaType: 'link',
      },
    })
  }

  static toggleOffEvent = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'callToAction',
      callToAction: {
        ctaName: 'toggle turn off',
        location: 'header',
        ctaType: 'button',
      },
    })
  }

  static editEvent = (processType) => {
    //Used to track process start
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processStart', //e119
      process: {
        newPageView: false, //string VALUE
        processType: processType, //c51,v51
      },
    })
  }

  static saveEditEvent = (processType: String) => {
    //Used to track process complete
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processComplete', //e120
      process: {
        newPageView: false, //STRING VALUE
        processType: processType, //c51,v51
      },
    })
  }

  static closeButtonEvent = (processType: String) => {
    //Used to track process
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processAbandonment', //e218
      process: {
        processType: processType, //c51,v51
        processStep: 'not available', //c54,v54
        processSideStep: 'not available', //c55, v55
      },
    })
  }

  static editStepProcessEvent = (processStep: string, processType: string) => {
    // Use to track step Process Event
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processStepSuccess',
      process: {
        processStep: processStep,
        processType: processType,
      },
    })
  }

  //Dashboard event.
  static dasboardEvent = (headerName: string) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'accordionClick',
      accordion: {
        accordionName: headerName,
      },
    })
  }

  //Use for tracking Internal Search Results
  static searchConducted = (searchTermEntered: any, eventName: any) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'internalSearchConducted', //e27
      searchInfo: {
        searchTermEntered: searchTermEntered, //c27,v27
        searchType: eventName, //v91
      },
    })
  }
  static seeAllPlansEvent = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'navigationPopup',
      navigationPopup: {
        linkName: 'employee profile:personal information:see all plans',
      },
    })
  }

  static investmentViewEdit = () => {
    //Used to track process start
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processStart', //e119
      process: {
        newPageView: false, //string VALUE
        processType: 'investments allocated resources', //c51,v51
      },
    })
  }

  static editFlowEvent = () => {
    //Used to track process step success
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processStepSuccess', //e16
      process: {
        processStep: 'edit', //c54,v54
        processType: 'investments allocated resources', //c51,v51
      },
    })
  }

  static nextFlowEvent = () => {
    //Used to track process step success
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processStepSuccess', //e16
      process: {
        processStep: 'next', //c54,v54
        processType: 'investments allocated resources', //c51,v51
      },
    })
  }

  static submitEvent = () => {
    //Used to track process complete
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processComplete', //e120
      process: {
        newPageView: false, //STRING VALUE
        processType: 'investments allocated resources', //c51,v51
      },
    })
  }

  static cancelEvent = () => {
    //Used to track process
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'processAbandonment', //e218
      process: {
        processType: 'investments allocated resources', //c51,v51
        processStep: 'edit', // or "next", //c54,v54
        processSideStep: 'not available', //c55, v55
      },
    })
  }

  static tabsChangeEvent = (ctaName: any) => {
    //Use to track the conversion of user
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'callToAction', //e111
      callToAction: {
        ctaName: ctaName, //v104
        location: 'employee profile', //v103
        ctaType: 'button', //v111
      },
    })
  }

  static applyBtnEvent = (ctaName: any) => {
    //Use to track the conversion of user
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'callToAction', //e111
      callToAction: {
        ctaName: ctaName, //v104
        location: 'employee profile', //v103
        ctaType: 'button', //v111
      },
    })
  }

  static downloadEvent = (link, name) => {
    //Use to track the download of content
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'contentDownloaded', //e24
      linkInfo: {
        fileName: name, //v70
        fileLocation: link, //v63
      },
    })
  }

  static subPageViewEvent = (subPage) => {
    //Used to track accordion clicks
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'accordionClick',
      accordion: {
        accordionName: subPage,
      },
    })
  }
  // static subPageViewEvent = (subPage) => {
  //   //Used to signify that a subPage was activated/viewed
  //   window.dataLayer = window.dataLayer || []
  //   window.dataLayer.push({
  //     event: 'subPageViewed', //e166
  //     subPage: {
  //       subPageID: subPage, //v105
  //       spClicked: true,
  //     },
  //   })
  // }

  // Adobe events ends here.

  // if num string is less than size, pad "0" char to the front of it
  static padStart(num: string[], size: number): string {
    let temp = num + ''
    while (temp.length < size) temp = '0' + temp
    return temp
  }
}
